<template>
  <div class="hello">

    <b-container>

        <table class='table'>
            <tbody>
                <tr @click="clickedIsBrewer(0)">
                    <td colspan='12'>
                        <div class="bg-success ksbutton isbrewerquestions">I am a <u style="font-weight:bolder">RETAILER</u>, buying beverages for resale (Bars, Pubs, Restaurants, Liquor Stores)</div>
                    </td>
                </tr>

                <tr @click="clickedIsBrewer(1)">
                    <td colspan='12'>
                        <div class="bg-primary ksbutton isbrewerquestions">I am a <u style="font-weight:bolder">BREWER</u> and I would like to sell my beverages</div>
                    </td>
                </tr>


                <tr v-if="allowDistributors"  @click="clickedIsBrewer(2)">
                    <td colspan='12'>
                        <div class="bg-warning ksbutton isbrewerquestions">I am a <u style="font-weight:bolder">DISTRIBUTOR</u> selling multiple brands of beverages</div>
                    </td>
                </tr>

                
                
            </tbody>
        </table>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {    

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'allowDistributors'])
    },

    components: {
    },

    data() {
        return {

        }
    },

    methods:{
        clickedIsBrewer(val){
            this.$store.commit('setNewUserIsBrewer', val)
            this.$emit('accounttypedone', {value: true});
        },
    },

    mounted(){
    },
}
</script>

<style scoped>
.modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
}

.isbrewerquestions {
    color: whitesmoke;
    padding:20px;
    cursor:pointer;
    font-size:20px;
    border:1px solid #f2f2f2;
    border-radius:20px
}

.test-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
}

.ksbutton:hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.25);
}

</style>

